// const BASEURL = 'https://lkmng.com/appointment_api/'

const BASEURL = 'https://ebooking.today/api/'


// const PREFIX = 'signage'
export { BASEURL }